var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label",class:_vm.labelClass},[_vm._v(_vm._s(_vm.title)),(_vm.help)?[_c('a',{staticClass:"icon has-text-link",attrs:{"title":_vm.help}},[_c('font-awesome-icon',{attrs:{"icon":"question-circle"}})],1)]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }